import type { EmergencyFormState } from '../types/emergencyFormState.types';

export const initialState: EmergencyFormState = {
  formData: {
    institutionId: undefined,
  },
};
